import AddressForm from "kinnect-front/Address/AddressForm";
import { Address } from "kinnect-models";
import { KListTile, KSelect } from "kinnect-general";
import { getObjectValueByPath } from "vuetify/lib/util/helpers";
import { sortByKey } from "kinnect-helpers";
import {
	VDialog,
	VIcon,
	VListItemContent,
	VListItemSubtitle,
	VListItemTitle
} from "vuetify/lib";

export default {
	name: "AddressField",

	extends: KSelect,

	props: {
		chips: {
			default: true,
			type: Boolean
		},
		customer: Object,
		itemText: {
			default: "alias",
			type: String
		},
		itemValue: {
			default: "id",
			type: String
		},
		persistentHint: {
			default: true,
			type: Boolean
		},
		prependIcon: {
			default: "place",
			type: String
		},
		showAddButton: Boolean
	},

	data: () => ( {
		dialogOpen: false
	} ),

	computed: {
		sortedItems() {
			return sortByKey( this.items, this.itemText );
		},

		selectedAddress() {
			return this.items.find( item => getObjectValueByPath( item, this.itemValue ) === this.value );
		},

		addressHint() {
			if ( this.hint ) {
				return this.hint;
			} else if ( this.selectedAddress ) {
				const a = this.selectedAddress;

				return `${a.address}, ${a.city}, ${a.state} ${a.zip}`;
			}

			return "";
		}
	},

	methods: {
		createAddress( { data: address } ) {
			this.$emit( "create", new Address( address ) );
		}
	},

	render() {
		return <KSelect
			attrs={{
				...this.$props,
				hint: this.addressHint,
				items: this.sortedItems
			}}
			on={{ ...this.$listeners }}
			scopedSlots={{
				item: ( { item } ) =>
					<VListItemContent>
						<VListItemTitle>
							{getObjectValueByPath( item, this.itemText )}
						</VListItemTitle>

						<VListItemSubtitle>
							{item.address}, {item.city}, {item.state} {item.zip}
						</VListItemSubtitle>
					</VListItemContent>
			}}
		>
			{this.showAddButton && <VDialog
				class="white"
				persistent
				scopedSlots={{ activator: ( { on } ) => <VIcon on={on}>add_circle</VIcon> }}
				slot="append-outer"
				vModel={this.dialogOpen}
				width="500"
			>
				{this.dialogOpen && <AddressForm
					formTitle={this.customer
						? `Add an Address for ${this.customer.name}`
						: "Add an Address"
					}
					idCustomer={this.customer ? this.customer.id : null}
					onClose={() => this.dialogOpen = false}
					onSuccess={this.createAddress}
				></AddressForm>}
			</VDialog>}

			<KListTile text="No addresses to display" slot="no-data"></KListTile>
		</KSelect>;
	}
};
